import React from 'react';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useMessagesContext } from 'Views/Page/Content/Templates/MessagesPage/MessagesContext';
import DataContainer from 'Components/UI/DataContainer';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import useMobileLayout from 'Hooks/useMobileLayout';
import { DataValueMap } from 'Helpers/Testing';
import {
  MessagesPanelContent,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/MessagesPanel/components/MessagesPanelContent';
import {
  MessagesPanelSkeleton,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/MessagesPanel/components/MessagesPanelContent/components/MessagesPanelSkeleton';
import { getSectionCardStyle } from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/styles';

const useStyles = buildUseStyles('MessagesPanelContentContainer', (theme) => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
  },
  desktopRoot: {
    ...getSectionCardStyle({ theme }),
    padding: theme.spacing(1),
  },
}));

const MessagesPanelContentContainer = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMobileLayout();

  const {
    isMessagesInitializing,
    messagesInitializingError,
    selectedThreadResource,
  } = useMessagesContext();

  const loading = isMessagesInitializing || messagesInitializingError || !selectedThreadResource;

  return (
    <Box
      className={classNames(classes.root, {
        [classes.desktopRoot]: !isMobile,
      })}
      {...DataValueMap.init('messages-page-panel-content').build()}
    >
      <DataContainer
        loading={loading}
        skeleton={MessagesPanelSkeleton}
        component={MessagesPanelContent}
      />
    </Box>
  );
};

export { MessagesPanelContentContainer };
